import { render, staticRenderFns } from "./UserLogo.vue?vue&type=template&id=ca3b497c&scoped=true&"
import script from "./UserLogo.vue?vue&type=script&lang=ts&"
export * from "./UserLogo.vue?vue&type=script&lang=ts&"
import style0 from "./UserLogo.vue?vue&type=style&index=0&id=ca3b497c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3b497c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VIcon,VRow})
